import apiClientService from "./ApiClientService";

// Jurnalul de acțiuni — doar admin.
// GET /audit-log?from&to&roles&instructorType&actor&actorId&subject&subjectUserId&categories&action&entityType&entityId&result&beforeId&limit
//   -> { items: [{ id, createdAt, actorId, actorRole, subjectUserId, category, action, entityType, entityId,
//        method, route, statusCode, success, ip, userAgent, durationMs, details,
//        actor: { id, name, email, role, deleted } | null, subject: {...} | null }], nextBeforeId }
// GET /audit-log/meta -> { categories, roles, instructorTypes, results, enabled }

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   throw new Error(msg);
}

function toQuery(filters = {}) {
   const params = new URLSearchParams();
   for (const [key, value] of Object.entries(filters)) {
      if (value === undefined || value === null || value === "") continue;
      if (Array.isArray(value)) {
         if (value.length) params.set(key, value.join(","));
      } else {
         params.set(key, String(value));
      }
   }
   const qs = params.toString();
   return qs ? `?${qs}` : "";
}

export async function getAuditLog(filters) {
   return readOrThrow(
      await apiClientService.get(`/audit-log${toQuery(filters)}`),
      "Nu am putut încărca jurnalul.",
   );
}

export async function getAuditLogMeta() {
   return readOrThrow(
      await apiClientService.get("/audit-log/meta"),
      "Nu am putut încărca filtrele jurnalului.",
   );
}

export { toQuery as auditLogQuery };
